/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/**
 * Sanitize html pipe.
 */
@Pipe({
    name: 'sanitizeHtml'
})

export class SanitizeHtmlPipe implements PipeTransform {

    /**
     * Default constructor.
     * 
     * @param sanitizer Dom sanitizer.
     */
    constructor(private sanitizer: DomSanitizer) {
    }

    /**
     * Transform function.
     * 
     * @param value String.
     * @returns SafeHtml.
     */
    transform(value: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
